module.exports = {
    contract: {
        contract_remark: 'Contract remark',
        select_contract_template: 'Contract template',
        contract_template_cannot_be_empty: 'Contract template cannot be empty',
    }

}